import { Color, Icon } from 'zens-storybook'
import React, { useState } from 'react'
import { ActivityIndicator, Platform, Pressable, PressableProps, StyleSheet, View, ViewStyle } from 'react-native'

const styles = StyleSheet.create({
  content: {
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: Color.greyBlue,
    padding: 3,
    paddingTop: 2,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: Color.greyBlue,
  },
  pressed: {
    backgroundColor: Color.darkGreyBlue,
    borderColor: Color.darkGreyBlue,
  },
  active: {
    borderColor: Color.darkGreyBlue,
  },
})

interface Props extends Omit<PressableProps, 'style'> {
  loading?: boolean
  style?: ViewStyle
  contentStyle?: ViewStyle
}
const RefreshButton = (props: Props) => {
  const { loading, style, contentStyle, ...otherProps } = props
  const [active, setActive] = useState(false)

  const updateActive = (value: boolean) => () => {
    setActive(value)
  }

  const renderContent = (state: { pressed: boolean }) => {
    const { pressed } = state

    const buttonStyle = [styles.content, pressed && styles.pressed, active && styles.active, contentStyle]

    return (
      <View style={buttonStyle}>
        {loading ? <ActivityIndicator color={Color.simplyWhite} /> : <Icon name="refresh" color={Color.simplyWhite} />}
      </View>
    )
  }
  return (
    <Pressable
      hitSlop={10}
      onFocus={updateActive(true)}
      onBlur={updateActive(false)}
      style={[
        Platform.select({
          // @ts-expect-error outline is not typed for react-native
          web: {
            outlineStyle: 'none',
          } as ViewStyle,
        }),
        style,
      ]}
      testID="RefreshButton.Container"
      {...otherProps}
    >
      {renderContent}
    </Pressable>
  )
}

export default RefreshButton
